import { Event } from '@mirai/data-sources';

import { createTrust } from './engine';
import { scopeKey } from './helpers';

const instances = new Map();

const getTrust = (store = {}) => {
  const value = store.trust || store.config?.trust;
  const config = Object.fromEntries(
    ['contactSignals', 'trustedScore']
      .filter((key) => value && typeof value === 'object' && value[key] !== undefined)
      .map((key) => [key, value[key]]),
  );
  const scope = scopeKey(store);
  const key = `${scope}:${JSON.stringify(config)}`;
  if (!instances.has(key)) {
    while (instances.size >= 20) {
      const oldest = [...instances].find(([, engine]) => !engine.isActive());
      if (!oldest) break;
      oldest[1].stop();
      instances.delete(oldest[0]);
    }
    instances.set(key, createTrust({ scope, config, publish: (event, payload) => Event.publish(event, payload) }));
  }
  const engine = instances.get(key);
  instances.delete(key);
  instances.set(key, engine);
  return engine;
};

export { getTrust };
